export type AuthRedirectReason =
  | "api_401"
  | "authx_exchange_failed"
  | "cognito_session_failed"
  | "manual_logout"
  | "reauthentication_required";

export class MustReauthenticateError extends Error {
  cause?: unknown;
  redirectReason: AuthRedirectReason;

  constructor(
    message: string,
    redirectReason: AuthRedirectReason,
    cause?: unknown,
  ) {
    super(message);
    this.name = "MustReauthenticateError";
    this.cause = cause;
    this.redirectReason = redirectReason;
    Object.setPrototypeOf(this, MustReauthenticateError.prototype);
  }
}
